import { 
  PRINTED, COLLATING, COLLATED, LAMINATING, LAMINATED, 
  CUT, VALIDATING, VALIDATED, PACKING 
} from '../../../ngrx/status-types';

export interface ScrapReason {
  code: string;       // e.g. "130"
  description: string; // e.g. "Process scrap Indigo"
  spanishDescription: string; // e.g. "Rechazo de Proceso Índigo"
}

export interface ScrapCategory {
  name: string;           // e.g. "HP INDIGO"
  applicableStatuses: string[]; // e.g. ["printed"]
  reasons: ScrapReason[];
}

// Scrap category constants
export const SCRAP_CATEGORIES = {
  HP_INDIGO: 'HP INDIGO',
  COLLATOR: 'COLLATOR/COLEADORA',
  LAMINATOR: 'LAMINATOR/LAMINADORA',
  PUNCH: 'PUNCH/PONCHADORA',
  VERIFICATOR: 'VERIFICATOR/VERIFICADORA'
};

// Define all scrap reasons grouped by category
export const SCRAP_CATEGORIES_DATA: ScrapCategory[] = [
  {
    name: SCRAP_CATEGORIES.HP_INDIGO,
    applicableStatuses: [PRINTED],
    reasons: [
      { code: '130', description: 'Process scrap Indigo', spanishDescription: 'Rechazo de Proceso Índigo' },
      { code: '161', description: 'Scrap Margin out of Spec', spanishDescription: 'Scrap Margen fuera de Espec.' },
      { code: '164', description: 'Scrap Set Up', spanishDescription: 'Ajustes de Set Up' },
      { code: '167', description: 'Scrap impression problems', spanishDescription: 'Problemas de impresión' },
      { code: '168', description: 'Scrap Machine Adjust', spanishDescription: 'Ajuste de la Máquina' },
      { code: '173', description: 'Maintenance', spanishDescription: 'Mantenimiento' },
      { code: '211', description: 'Scrap start production', spanishDescription: 'Scrap Inicio de Producción' },
      { code: '528', description: 'Scrap QA rejectings', spanishDescription: 'Rechazo QA' }
    ]
  },
  {
    name: SCRAP_CATEGORIES.COLLATOR,
    applicableStatuses: [COLLATING, COLLATED],
    reasons: [
      { code: '23', description: 'Validation samples (Engineering, Maintenance, etc.)', spanishDescription: 'Muestras de validación (Ingeniería, Mantenimiento, etc.)' },
      { code: '161', description: 'Scrap Margin out of Spec', spanishDescription: 'Margen fuera de Espec.' },
      { code: '164', description: 'Scrap Set Up', spanishDescription: 'Ajuste de Set Up' },
      { code: '166', description: 'Scrap Roll (Papel, Vinyl, Tape, Etc)', spanishDescription: 'Rechazo Rollo (Papel, Vinilo, Cinta, Etc.)' },
      { code: '168', description: 'Scrap Machine Adjust', spanishDescription: 'Ajuste de la máquina' },
      { code: '173', description: 'Maintenance', spanishDescription: 'Mantenimiento' },
      { code: '174', description: 'Roll Change (Papel, Vinyl,Tape, Mylar etc)', spanishDescription: 'Cambio de Rollo (Papel, Vinilo, Cinta, Mylar etc.)' },
      { code: '211', description: 'Scrap start production', spanishDescription: 'Scrap Inicio de Producción' },
      { code: '416', description: 'Cutting scrap', spanishDescription: 'Scrap por corte' },
      { code: '438', description: 'Bad sealed', spanishDescription: 'Mal sellado' },
      { code: '528', description: 'Scrap QA rejectings', spanishDescription: 'Rechazo QA' }
    ]
  },
  {
    name: SCRAP_CATEGORIES.LAMINATOR,
    applicableStatuses: [LAMINATING, LAMINATED],
    reasons: [
      { code: '23', description: 'Validation samples (Engineering, Maintenance, etc.)', spanishDescription: 'Muestras de validación (Ingeniería, Mantenimiento, etc.)' },
      { code: '161', description: 'Scrap Margin out of Spec', spanishDescription: 'scrap Margen fuera de Espec.' },
      { code: '164', description: 'Scrap Set Up', spanishDescription: 'Ajustes de Set Up' },
      { code: '168', description: 'Scrap Machine Adjust', spanishDescription: 'Ajuste de la Máquina' },
      { code: '173', description: 'Maintenance', spanishDescription: 'Mantenimiento' },
      { code: '211', description: 'Scrap start production', spanishDescription: 'Scrap Inicio de Producción' },
      { code: '438', description: 'Bad sealed', spanishDescription: 'Mal sellado' },
      { code: '528', description: 'Scrap QA rejectings', spanishDescription: 'Rechazo QA' }
    ]
  },
  {
    name: SCRAP_CATEGORIES.PUNCH,
    applicableStatuses: [CUT],
    reasons: [
      { code: '23', description: 'Validation samples (Engineering, Maintenance, etc.)', spanishDescription: 'Muestras de validación (Ingeniería, Mantenimiento, etc.)' },
      { code: '161', description: 'Scrap Margin out of Spec', spanishDescription: 'Scrap Margen fuera de Espec.' },
      { code: '164', description: 'Scrap Set Up', spanishDescription: 'Ajustes de Set Up' },
      { code: '168', description: 'Scrap Machine Adjust', spanishDescription: 'Ajuste de la Máquina' },
      { code: '173', description: 'Maintenance', spanishDescription: 'Mantenimiento' },
      { code: '211', description: 'Scrap start production', spanishDescription: 'Scrap Inicio de Producción' },
      { code: '416', description: 'Cutting scrap', spanishDescription: 'Scrap por corte' },
      { code: '417', description: 'Scrap por dado', spanishDescription: 'Dañado (desgastado, golpeado, fuera de espec, etc)' },
      { code: '438', description: 'Bad sealed', spanishDescription: 'Mal sellado' },
      { code: '528', description: 'Scrap QA rejectings', spanishDescription: 'Rechazo QA' }
    ]
  },
  {
    name: SCRAP_CATEGORIES.VERIFICATOR,
    applicableStatuses: [VALIDATING, VALIDATED, PACKING], // Also for excess cards
    reasons: [
      { code: '528', description: 'Scrap QA rejectings', spanishDescription: 'Rechazos de control de ecalidad' }
    ]
  }
];

// Function to get applicable scrap reasons for a given job status
export function getScrapReasonsForStatus(status: string): ScrapCategory[] {
  return SCRAP_CATEGORIES_DATA.filter(category => 
    category.applicableStatuses.indexOf(status) !== -1
  );
}

// Function to find a scrap reason by code within all categories
export function findScrapReasonByCode(code: string): { category: string, reason: ScrapReason } | null {
  for (const category of SCRAP_CATEGORIES_DATA) {
    const reason = category.reasons.find(r => r.code === code);
    if (reason) {
      return { category: category.name, reason };
    }
  }
  return null;
}

// Export the special case constant for excess cards
export const EXCESS_CARDS_SCRAP_CODE = '528'; // Using QA rejections code for excess cards 


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/models/scrap-reasons.model.ts